import { runRemoteCommand } from "./Util.ts";

export async function checkPasswordStrength(strength: string): Promise<number> {
  const result = await runRemoteCommand(BackendCommand?.checkPasswordStrength, [{ name: "pwd", value: strength }]);
  return result.pwdStrength ?? 0;
}
